import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

function AddNewCityModal({
  isLoadingAddNewCity,
  stateList,
  isAddNewCityModal,
  handleAddNewCityHide,
  formik,
  onClickOfAddNewCityCancelButton,
}) {
  return (
    <>
      <Modal
        show={isAddNewCityModal}
        onHide={handleAddNewCityHide}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {`Add New City`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`City Name`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`City Name`}
                  name="name"
                  {...formik.getFieldProps("name")}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-4  d-none">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formik.getFieldProps("status")}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {formik.touched.status && formik.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.status}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select State`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="state_name"
                  {...formik.getFieldProps("state_name")}
                >
                  {stateList &&
                    stateList.map((state, index) => (
                      <option value={state.state_name} key={index}>
                        {state.state_name}
                      </option>
                    ))}
                </select>
                {formik.touched.state_name && formik.errors.state_name ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.state_name}
                  </div>
                ) : null}
              </div>
            </div>
            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8 mt-8">
              <Button
                variant="btn btn-success mr-3"
                type="submit"
                disabled={isLoadingAddNewCity}
              >
                {`Add`}
                {isLoadingAddNewCity && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={onClickOfAddNewCityCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AddNewCityModal;
